import React, { useMemo } from "react";

import { Box, SystemProps } from "@storyofams/react-ui";

import Image from "next/image";
import { PhotoView } from "react-photo-view";
import { css } from "styled-components";
import { Video } from "~components/common/Story/blocks/Video";

interface ModalProps extends SystemProps {
  images?: string;
  videos?: string;
}

export const Media = ({ images, videos }: ModalProps) => {
  const content = useMemo(() => {
    return [
      ...videos
        .trim()
        .split(",")
        .filter((item) => item),
      ...images
        .trim()
        .split(",")
        .filter((item) => item),
    ]
      .map((item) =>
        item.includes(".img") ||
        item.includes(".jpeg") ||
        item.includes(".png") ||
        item.includes(".jpg")
          ? { url: item, type: "image" }
          : { url: item, type: "video" }
      )
      .sort((item) => (item.type === "video" ? 1 : 0));
  }, []);
  return (
    <Box display={["flex", "none"]}>
      {content.map(({ url, type }) => (
        <Box>
          {type === "video" ? (
            <Box
              ml={1}
              key={url}
              mt={1}
              width={102}
              height={76}
              borderRadius="none"
            >
              <Video
                width="100%"
                content={{
                  url,
                }}
              />
            </Box>
          ) : (
            <Box key={url} mt={1} ml={1} cursor="pointer">
              <Box
                css={css({
                  img: {
                    borderRadius: "8px",
                  },
                })}
              >
                <PhotoView src={url}>
                  <Image src={url} width={102} height={76} objectFit="cover" />
                </PhotoView>
              </Box>
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
};
